/**
 * @generated SignedSource<<d2b8dc576d971dfb3011944a9814ee0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "enhancedText" | "file" | "freeTextSelfCheck" | "markMistakes" | "matrix" | "multipleChoice" | "order" | "persolog" | "persologEvaluation" | "persologQuestion" | "podcast" | "podcastWithTimestamp" | "reminder" | "text" | "textWithPages" | "video";
import { FragmentRefs } from "relay-runtime";
export type elementForm_ElementV2Fragment$data = {
  readonly elementType: ElementTypeV2;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ClozeTextElementForm_ClozeTextElementFragment" | "MarkMistakeElementForm_MarkMistakeElementFragment" | "OrderElementForm_OrderElementFragment" | "PodcastWithTimestampElementForm_PodcastWithTimestampElementFragment" | "enhancedTextElementForm_EnhancedTextElementFragment" | "fileElementForm_FileElementV2Fragment" | "freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment" | "matrixElementForm_MatrixElementFragment" | "multipleChoiceElementForm_MultipleChoiceElementV2Fragment" | "persologElementForm_PersologElementFragment" | "reminderElementForm_ReminderElementFragment" | "textElementForm_TextElementFragment" | "textWithPagesElementForm_TextWithPagesElementFragment" | "videoElementForm_VideoElementFragment">;
  readonly " $fragmentType": "elementForm_ElementV2Fragment";
};
export type elementForm_ElementV2Fragment$key = {
  readonly " $data"?: elementForm_ElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"elementForm_ElementV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "elementForm_ElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elementType",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "fileElementForm_FileElementV2Fragment"
        }
      ],
      "type": "FileElementV2",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "videoElementForm_VideoElementFragment"
        }
      ],
      "type": "VideoElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "multipleChoiceElementForm_MultipleChoiceElementV2Fragment"
        }
      ],
      "type": "MultipleChoiceElementV2",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MarkMistakeElementForm_MarkMistakeElementFragment"
        }
      ],
      "type": "MarkMistakesElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PodcastWithTimestampElementForm_PodcastWithTimestampElementFragment"
        }
      ],
      "type": "PodcastWithTimestamp",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "matrixElementForm_MatrixElementFragment"
        }
      ],
      "type": "MatrixElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "enhancedTextElementForm_EnhancedTextElementFragment"
        }
      ],
      "type": "EnhancedTextElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrderElementForm_OrderElementFragment"
        }
      ],
      "type": "OrderElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ClozeTextElementForm_ClozeTextElementFragment"
        }
      ],
      "type": "ClozeTextElementV2",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "textElementForm_TextElementFragment"
        }
      ],
      "type": "TextElementV2",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "textWithPagesElementForm_TextWithPagesElementFragment"
        }
      ],
      "type": "TextWithPagesElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "persologElementForm_PersologElementFragment"
        }
      ],
      "type": "Persolog_PersologElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "reminderElementForm_ReminderElementFragment"
        }
      ],
      "type": "ReminderElement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment"
        }
      ],
      "type": "FreeTextSelfCheckElement",
      "abstractKey": null
    }
  ],
  "type": "ElementV2",
  "abstractKey": "__isElementV2"
};

(node as any).hash = "e5f864917035d687586e9078433a6506";

export default node;
